// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"affb3f3d","190":"3952a13d","262":"c499e2ed","413":"dee62c2c","538":"16c0f19b","566":"8e778c5d","676":"5bb91237","943":"10d78250"}[chunkId] + ".chunk.js";
};